import { Installation } from "../Installation";
import { CashValueByCashType } from "./CashValueByCashType";

export class InstallationCashFlowSummary extends Installation {
    currency: string;
    cashIn: number;
    cashOut: number;
    balance: number;

    initialContent: number;
    finalContent: number;

    firstTransactionTimestamp: Date;
    lastTransactionTimestamp: Date;

    /**
     * Per una macchina di front office: somma di tutti gli importi che sono stati spediti da macchine di back office
     * Per una macchina di back office: somma di tutti gli importi provenienti da macchine di front office
     */
    fromOtherOffice: CashValueByCashType;
    /**
     * Per una macchina di front office: somma di tutti gli importi che sono finiti in macchine di back office
     * Per una macchina di back office: somma di tutti gli importi destinati a macchine di front office
     */
    toOtherOffice: CashValueByCashType;

    constructor() {
        super();
    }

    public parse(obj: any) {
        super.parse(obj);

        if (obj.Currency) this.currency = obj.Currency;
        if (obj.CashIn != null) this.cashIn = obj.CashIn;
        if (obj.CashOut != null) this.cashOut = obj.CashOut;
        if (obj.Balance != null) this.balance = obj.Balance;

        if (obj.InitialContent != null) this.initialContent = obj.InitialContent;
        if (obj.FinalContent != null) this.finalContent = obj.FinalContent;

        if (obj.FirstTransactionTimestamp != null) this.firstTransactionTimestamp = obj.FirstTransactionTimestamp;

        if (obj.LastTransactionTimestamp != null) this.lastTransactionTimestamp = obj.LastTransactionTimestamp;

        if (obj.FromOtherOffice) {
            this.fromOtherOffice = new CashValueByCashType();
            this.fromOtherOffice.parse(obj.FromOtherOffice);
        }

        if (obj.ToOtherOffice) {
            this.toOtherOffice = new CashValueByCashType();
            this.toOtherOffice.parse(obj.ToOtherOffice);
        }
    }
}
